import { imageSchema, universalLink } from '../../questions/schemaFields';
import { createBasicFinalSchema } from '../schemaFields';

export const schema = createBasicFinalSchema(
  'FINAL_CLICK_PAGE',
  {
    image: imageSchema,
    text: { type: 'string' },
    offer: { type: 'string' },
    additionalText: { type: 'string' },
    background: { type: 'string' },
    cta: { type: 'string' },
    ctaUrl: universalLink,
    footer: { type: 'string' },
    alignContent: { enum: ['center', 'left'] },
    hasAutoClose: { type: 'boolean' },
    autoCloseMs: { type: 'number' },
    autoCloseRedirectLink: universalLink,
  } as const,
  ['offer', 'alignContent'],
);
